import UserIcon from '@mui/icons-material/People'
import list from './AttendantUserList'
import create from './AttendantUserCreate'
import edit from './AttendantUserEdit'
import show from './AttendantUserShow'

export default {
  edit,
  list,
  create,
  show,
  name: 'attendant-employees',
  permissions: [],
  options: { label: 'Usuários frentistas' },
  icon: UserIcon,
}
